import React from 'react';
import { HiOutlineSparkles } from 'react-icons/hi';

function Loading1() {
    return (
        <div className="fixed inset-0 z-[10000] flex flex-col items-center justify-center bg-white">
            <div className="relative">
                {/* Rotating Ring */}
                <div className="w-24 h-24 rounded-full border-t-2 border-primary animate-spin"></div>
                
                {/* Static Ring */}
                <div className="absolute inset-0 w-24 h-24 rounded-full border-2 border-primary/10"></div>
                
                {/* Center Icon */}
                <div className="absolute inset-0 flex items-center justify-center text-primary animate-pulse">
                    <HiOutlineSparkles size={32} />
                </div>
            </div>
            
            <div className="mt-8 text-center space-y-2">
                <span className="text-[10px] font-black uppercase tracking-[0.5em] text-primary block">AstraClean</span>
                <p className="text-xs font-bold text-muted-foreground uppercase tracking-widest animate-pulse">
                    Preparing your <span className="text-foreground">premium</span> experience
                </p>
            </div>
            
            {/* Decorative ground gradient */}
            <div className="absolute bottom-0 left-0 w-full h-1/4 bg-gradient-to-t from-secondary/30 to-transparent -z-10"></div>
        </div>
    );
}

export default Loading1;